import React, { useState, useEffect } from 'react';
import './SettingsModal.css';

const SettingsModal = ({ isOpen, onClose, currentMode, onModeChange, btInstance, showToast }) => {
    const [brandId, setBrandId] = useState('');
    const [token, setToken] = useState('');
    const [theme, setTheme] = useState('default-table');
    const [language, setLanguage] = useState('en-x-sweepstk');

    useEffect(() => {
        if (currentMode) {
            setBrandId(currentMode === 'gc' ? '2615125477509177346' : '2615125477509177345');
            updateToken(currentMode);
        }
    }, [currentMode]);

    const updateToken = (mode) => {
        if (mode === 'gc') {
            setToken("eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJpc3MiOiIyNjE1MTI1NDc3NTA5MTc3MzQ2IiwiYXVkIjoiMjYxNTEyNTQ3NzUwOTE3NzM0NiIsImlhdCI6MTc2NzYwODEwOCwiZXhwIjoxODAzNjA4MTA4LCJzdWIiOiJwbGF5ZXIxMjMiLCJuYW1lIjoiQWxpY2UiLCJjdXJyZW5jeSI6IlVTRCIsImxhbmciOiJlbiIsImp0aSI6Ijc1YmU5OWU2LTQzZjUtNDcxYi1hODdhLThlZDk2YmMyZTI3ZSIsIm9kZHNfZm9ybWF0IjoiZGVjaW1hbCJ9.lNP5Mz6pIQ4FW8-XcN4WPv5mnvwQAOGPKcnvIywmZr-kMfzjchIeWwu9cFpiqCwwQieio94YFERYhWFxGGJd8g");
        } else {
            setToken("eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJpc3MiOiIyNjE1MTI1NDc3NTA5MTc3MzQ1IiwiYXVkIjoiMjYxNTEyNTQ3NzUwOTE3NzM0NSIsImlhdCI6MTc2NzYwODI5MCwiZXhwIjoxODAzNjA4MjkwLCJzdWIiOiJwbGF5ZXIxMjMiLCJuYW1lIjoiQWxpY2UiLCJjdXJyZW5jeSI6IlVTRCIsImxhbmciOiJlbiIsImp0aSI6ImUyODc5NDg2LTIzNDgtNGFlYi1iMDJhLWNlMTA1NzE5YzI0YyIsIm9kZHNfZm9ybWF0IjoiZGVjaW1hbCJ9.Y4TEMPCYaF7IziTFBj1Gbr0NKhNUJx5glrBthwAgyj7zk_x-u4vooU0zaKiWjvI1mPTennMw1OZ89sOrpF33Dg");
        }
    };

    const handleBrandIdChange = (e) => {
        const newBrandId = e.target.value;
        setBrandId(newBrandId);
        updateToken(newBrandId === '2615125477509177346' ? 'gc' : 'sc');
    };

    const applySettings = () => {
        if (!btInstance) {
            showToast('Application not initialized');
            return;
        }

        try {
            btInstance.updateOptions({
                themeName: theme,
                lang: language,
                token: token
            });

            // Update mode if brandId changed
            const newMode = brandId === '2615125477509177346' ? 'gc' : 'sc';
            if (newMode !== currentMode) {
                onModeChange(newMode);
            }

            showToast('Settings applied successfully');
            onClose();
        } catch (error) {
            console.error('Update error:', error);
            showToast('Settings failed: ' + error.message);
        }
    };

    const resetSettings = () => {
        setTheme('default-table');
        setLanguage('en-x-sweepstk');
        setBrandId(currentMode === 'gc' ? '2615125477509177346' : '2615125477509177345');
        updateToken(currentMode);
        showToast('Settings reset to default');
    };

    if (!isOpen) return null;

    return (
        <div className="settings-modal-overlay" onClick={onClose}>
            <div className="settings-content" onClick={(e) => e.stopPropagation()}>
                <div className="settings-header">
                    <h2 className="settings-title">Settings</h2>
                    <button className="close-settings-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="settings-body">
                    <div className="form-group">
                        <label htmlFor="brandId">Brand ID</label>
                        <select 
                            id="brandId" 
                            value={brandId}
                            onChange={handleBrandIdChange}
                        >
                            <option value="2615125477509177346">GC</option>
                            <option value="2615125477509177345">SC</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="token">JWT Token</label>
                        <input 
                            type="text" 
                            id="token" 
                            value={token}
                            onChange={(e) => setToken(e.target.value)}
                            placeholder="JWT Token" 
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="theme">Theme</label>
                        <select 
                            id="theme"
                            value={theme}
                            onChange={(e) => setTheme(e.target.value)}
                        >
                            <option value="default-table">default-table</option>
                            <option value="default">Default</option>
                            <option value="dark">Dark</option>
                            <option value="light">Light</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="language">Language</label>
                        <select 
                            id="language"
                            value={language}
                            onChange={(e) => setLanguage(e.target.value)}
                        >
                            <option value="en-x-sweepstk">en-x-sweepstk</option>
                            <option value="en">English</option>
                            <option value="zh">Chinese</option>
                            <option value="pt">Portuguese</option>
                            <option value="es">Spanish</option>
                        </select>
                    </div>

                    <div className="btn-group">
                        <button 
                            className="btn btn-primary" 
                            onClick={applySettings}
                        >
                            Apply Settings
                        </button>
                        <button 
                            className="btn btn-secondary" 
                            onClick={resetSettings}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsModal;